<template>
  <svg
    width="7"
    height="4"
    viewBox="0 0 7 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.48 3.488H0.72V0.896H6.48V3.488Z" fill="currentColor" />
  </svg>
</template>
